<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Tabs :animated="false">
      <TabPane label="基础信息">
        <Row :gutter="12">
          <Col span="24">
            <sl-label title="订单状态" :content="data.info.orderStateText" />
          </Col>
          <Col span="24">
            <sl-label title="流程状态" :content="data.info.flowStateText" />
          </Col>
          <Col span="24">
            <sl-label title="支付方式" :content="data.info.payTypeText" />
          </Col>
          <Col span="24">
            <sl-label title="订单金额" :content="data.info.totalAmount" />
          </Col>
          <Col span="24">
            <sl-label title="下单时间" :content="data.info.dealDatetimeText" />
          </Col>
          <Col span="24">
            <sl-label title="备注" :content="data.info.remark" />
          </Col>
        </Row>
        
<!--         <Divider orientation="left" class="margin-top"></Divider>

        <order-info :data="data.info"></order-info> -->
      </TabPane>
<!--       <TabPane label="文件清单">
        <order-annex :order-id="id" :data="data.annexs"></order-annex>
      </TabPane> -->
      <TabPane label="购买人信息">
        <order-buyer :order-id="id"></order-buyer>
      </TabPane>

      <TabPane label="商品信息">
        <order-goods :order-id="id"></order-goods>
      </TabPane>

      <TabPane label="企业信息">
        <order-company :order-id="id" :type="2"></order-company>
      </TabPane>
      <TabPane label="金融产品" :disabled="!data.info.isStages">
        <order-installment :datas="this.data.finance"></order-installment>
      </TabPane>
      <!-- <TabPane label="保险">
        <order-insurance :order-id="id"></order-insurance>
      </TabPane> -->
      <TabPane label="补充信息" :disabled="!!data.info.isStages">
        <order-extra :order-id="id" />
      </TabPane>
    </Tabs>
  </sl-side-panel>
</template>
<script>

import orderCompany from './partial/company'
import orderInstallment from './partial/installment'
import orderInsurance from './partial/insurance'
import orderBuyer from './partial/buyer'
import orderGoods from './partial/goods'
import orderAnnex from './partial/annex'
import orderInfo from './partial/info'
import orderExtra from './partial/extra'
export default {
  components: { orderBuyer , orderGoods , orderInstallment , orderInsurance , orderAnnex , orderInfo , orderCompany , orderExtra },

  data() {
    return {
      loading: false,
      id: null,
      modalVisible:false,
      data:{
        info:{} , 
        annexs:[]
      },
    }
  },
  computed:{
    itemTitle(){
      return '订单编号：' + this.data.info.orderNo
    }
  },
  mounted() {},

  methods: {
    query() {
      if (this.id) {
        this.loading = true
        this.$request.order(this.id).then(resp => {
          if( !resp.code ){
            this.$utils.conv(resp.data.info,{'dealDatetime':'time' , 'cancelDatetime':'time' , 'payType':'$payType' , 'orderState':'$orderState' , 'flowState':'$flowState'})
           
            this.data = resp.data

            this.data.annexs = resp.data.annexs || []

            this.data.info = resp.data.info || {}

            this.data.finance = resp.data.finance || { orderId : this.id }

            this.data.finance.flowState = resp.data.info.flowState

            this.data.finance.goods = resp.data.goods.map( i => i.skuId )

            this.data.finance.totalAmount = resp.data.info.totalAmount
            
            this.data.finance.buySubject = resp.data.info.buySubject

            resp.data.finance.stagesMonth = resp.data.finance.stagesYear
            
            this.loading = false
          }
        })
      }
    },

    init( id ){
      this.reset()
      this.id = id
      this.modalVisible = true
      this.query()
    }, 

    reset(){

      this.data = {
        info:{} , annexs:[]
      }
    },

    handleClose() {

    }
  }
}

</script>

<style lang='scss' scoped>
  .margin-top{
    margin-top:35px;
  }
</style>